import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useCurrentUser, usePrevious } from '@lib/hooks';
import usePermissions from 'hooks/usePermissions';

export default function useDatadogStartSessionReplayRecording() {
  const currentUser = useCurrentUser();
  const prevUserId = usePrevious(currentUser?.id);
  const { permissions } = usePermissions();

  React.useEffect(() => {
    // Start datadogSessionReplay only for real Users
    if (
      currentUser &&
      prevUserId !== currentUser.id &&
      !permissions?.isLumaUser &&
      !permissions?.isDemoAccount &&
      process.env.REACT_APP_POD_NAME === 'production'
    ) {
      datadogRum.startSessionReplayRecording();
    }
  }, [currentUser, permissions?.isDemoAccount, permissions?.isLumaUser, prevUserId]);

  return null;
}
